import React, { useState } from 'react';
import { Box, SimpleGrid } from '@hover/blueprint';
import { PRICING_PAGE_TABLE_HEADER } from '../../../../constants';
import { IPricingTableHeader } from '../../../../interfaces/IPricingTableHeader';
import HeaderCard from '../HeaderCard';
import { DownloadAppModal } from '../../../common';

interface Props {
  headerVisible: boolean;
}

const HeaderCards: React.FC<Props> = ({ headerVisible }) => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const toggleModal = () => setOpen(!isOpen);

  return (
    <>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <SimpleGrid
        columns={6}
        spacing={600}
        mb={headerVisible ? '10px' : 0}
        transition="margin 0.2s linear"
      >
        <Box />
        <Box />
        {PRICING_PAGE_TABLE_HEADER.map((card: IPricingTableHeader) => (
          <HeaderCard onLinkClick={toggleModal} key={card.id} card={card} />
        ))}
      </SimpleGrid>
    </>
  );
};

export default HeaderCards;
